import type { FixedExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const fixedResolver =
  createSimpleNamedExpressionResolver<FixedExpression>('fixed', (num, digits) =>
    num?.toFixed(digits)
  );
